import { toLower } from 'lodash-es'
import { ConfigProvider } from 'antd'
import type { DefaultOptionType } from 'antd/es/select'
import {
  type ISelectDropdownProps,
  SelectDropdown
} from '@jana-technology/lht-select-dropdown'

import './selectDropdownWrapper.scss'

/**
 * Wrapper around Select dropdown
 *
 * NOTE: For app specific customizations ONLY!
 * For addition of general/shared features, please try to
 * update the Select component upstream.
 */
export const SelectDropdownWrapper = <
  OptionType extends DefaultOptionType = DefaultOptionType
>({
  className,
  ...props
}: ISelectDropdownProps<OptionType>) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          // borderRadius: 4,
          // boxShadowSecondary: 'none',
        }
      }}
    >
      <SelectDropdown
        filterOption={(searchValue, options) => {
          return toLower(options?.label?.toString()).includes(
            toLower(searchValue)
          )
        }}
        {...props}
        dropdownStyle={{ width: '320px' }}
        className={`select-dropdown-wrapper ${className}`}
      />
    </ConfigProvider>
  )
}
